export default {
	MODAL_HEADER_PRODUCT_NAME: 'Product name',
	MODAL_HEADER_TO_STAY_PRICE: 'To stay price',
	MODAL_HEADER_TO_GO_PRICE: 'To go price',
	TABLE_TITLE: 'Ingredient associated discounts',
};
